export default "__VITE_ASSET__ad38f1a5__"